import * as z from 'zod';

import { nullableBooleanQuerySchema } from '@/_schemas/generic';

export const inventoryVendorQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string().min(1),
  minimum_order_required: nullableBooleanQuerySchema(),
});

export type InventoryVendorQueryLinkerSchema = z.infer<typeof inventoryVendorQueryLinkerSchema>;
